const JOBS_KEY_PREFIX = 'optimizationSuggestionJobs_v2_';
const LEGACY_KEY_PREFIX = 'optimizationSuggestionJob_';

/** @returns {{ google?: string, meta?: string, legacyJobId?: string }} */
export const readJobMap = (brandId) => {
  if (!brandId) return {};
  let v2KeyPresent = false;
  try {
    const raw = window.localStorage.getItem(`${JOBS_KEY_PREFIX}${brandId}`);
    if (raw != null) {
      v2KeyPresent = true;
      const o = JSON.parse(raw);
      if (o && typeof o === 'object') {
        return {
          google: typeof o.google === 'string' ? o.google : undefined,
          meta: typeof o.meta === 'string' ? o.meta : undefined,
        };
      }
    }
  } catch (e) {
    console.warn('optimizationJobStorage readJobMap failed:', e);
  }
  if (v2KeyPresent) {
    return {};
  }
  try {
    const legacy = window.localStorage.getItem(`${LEGACY_KEY_PREFIX}${brandId}`);
    if (legacy) {
      return { legacyJobId: legacy };
    }
  } catch (e) {
    console.warn('optimizationJobStorage legacy read failed:', e);
  }
  return {};
};

const writeJobMapInternal = (brandId, map) => {
  if (!brandId) return;
  const google = map.google;
  const meta = map.meta;
  if (!google && !meta) {
    try {
      window.localStorage.removeItem(`${JOBS_KEY_PREFIX}${brandId}`);
    } catch (e) {
      console.warn('optimizationJobStorage removeItem failed:', e);
    }
    return;
  }
  try {
    window.localStorage.setItem(
      `${JOBS_KEY_PREFIX}${brandId}`,
      JSON.stringify({
        ...(google ? { google } : {}),
        ...(meta ? { meta } : {}),
      })
    );
  } catch (e) {
    console.warn('optimizationJobStorage setItem failed:', e);
  }
};

export const removeLegacyJobKey = (brandId) => {
  if (!brandId) return;
  try {
    window.localStorage.removeItem(`${LEGACY_KEY_PREFIX}${brandId}`);
  } catch (e) {
    console.warn('optimizationJobStorage legacy remove failed:', e);
  }
};

/** @param {'google'|'meta'} platform */
export const setJobSlot = (brandId, platform, jobId) => {
  if (!brandId || !jobId || (platform !== 'google' && platform !== 'meta')) return;
  removeLegacyJobKey(brandId);
  const cur = readJobMap(brandId);
  writeJobMapInternal(brandId, { ...cur, [platform]: jobId });
};

/** @param {'google'|'meta'} platform */
export const clearJobSlot = (brandId, platform) => {
  if (!brandId || (platform !== 'google' && platform !== 'meta')) return;
  const cur = readJobMap(brandId);
  delete cur.legacyJobId;
  const next = { ...cur };
  delete next[platform];
  writeJobMapInternal(brandId, next);
};

export const clearAllJobSlots = (brandId) => {
  if (!brandId) return;
  try {
    window.localStorage.removeItem(`${JOBS_KEY_PREFIX}${brandId}`);
    window.localStorage.removeItem(`${LEGACY_KEY_PREFIX}${brandId}`);
  } catch (e) {
    console.warn('optimizationJobStorage clearAll failed:', e);
  }
};

/** @deprecated use readJobMap — kept for grep / external imports */
export const getJob = (brandId) => {
  const m = readJobMap(brandId);
  return m.legacyJobId || m.google || m.meta || null;
};

/** @deprecated use setJobSlot */
export const setJob = (brandId, jobId) => {
  if (!brandId || !jobId) return;
  setJobSlot(brandId, 'google', jobId);
};

/** @deprecated use clearAllJobSlots */
export const clearJob = (brandId) => {
  clearAllJobSlots(brandId);
};
